import React from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";
import { Container, Row, Col } from "reactstrap";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class Video extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    const currentPayload = this.props?.payload;
    const nextPayload = nextProp?.payload;

    // console.log(JSON.stringify(currentPayload) === JSON.stringify(nextPayload));
    if (isEqual(currentPayload, nextPayload)) {
      return false;
    }
    // console.log("re-render");
    return true;
  }

  _generateVideo = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    let { videoUrl } = payload.datas || {};
    const { videoWidth, videoHeight } = payload.datas || {};

    if (payload.datas && payload.datas["videoUrl_" + this.props.currentLang])
      videoUrl = payload.datas["videoUrl_" + this.props.currentLang];

    const cssSettings = generateStyle(payload, "container");
    const cssAlignment = generateStyle(payload, "alignment");

    const finalVideoUrl =
      videoUrl || "https://www.youtube.com/watch?v=k2m2g3U0KIQ&";

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div className="video-player" style={cssAlignment}>
              <div className="overlay-player"></div>
              <ReactPlayer
                url={finalVideoUrl}
                width={videoWidth ? parseInt(videoWidth) : 800}
                height={videoHeight ? parseInt(videoHeight) : 600}
                style={{ maxWidth: "100%", margin: "auto" }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return this._generateVideo();
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._generateVideo()}
      </Draggable>
    );
  }
}

Video.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Video);
